
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import { currentChatbotCharacter, chatbotProfilePicture } from '../utilities/config'
import { Helpers } from '../utilities/helpers'
import TypeIt from 'typeit-react'
import moment from 'moment';
import { useIntercom } from 'react-use-intercom';

const ChatBot = forwardRef((props, ref) => {
  const [text, setText] = useState(undefined)
  const [instance, setInstance] = useState(null)
  const [isVisible, setIsVisible] = useState(false)
  const {isHidden = false, isDarkMode=false, product} = props // Props with default values

  const { show } = useIntercom();

  const speak = async (step, dynamicWord) => {
    setIsVisible(!isHidden && true)
    let sentence = await Helpers.chatBotInteraction(step, currentChatbotCharacter, dynamicWord)
    // this set timeout gives the chatbot enough
    // time to write to the DOM before talking
    setTimeout(() => {
      setText(sentence)
    }, 500)
  }

  // exposes the component to be ref'd
  useImperativeHandle(ref, () => ({
    speak
  }))

  useEffect(() => {
    if (instance && text) {
      instance.empty()
      instance.type(text).flush()
    }
  }, [text])

  return (
    <div>
      {
        isVisible ?
        <div className={`chat-bot-parent-wrapper ${isDarkMode ? 'chat-bot-parent-wrapper--dark-mode' : ''}`}>
          <div className="chat-bot-img-wrapper">
            <img className='chat-bot-img' src={chatbotProfilePicture} />
          </div>
            <div className={`chat-bot-text-wrapper ${isDarkMode ? 'chat-bot-text-wrapper--dark-mode' : ''}`}>
            <svg className='chat-bot-text-wrapper-arrow p-0'>
              {/* Bottom Line */}
              <line className={`chat-bot-text-wrapper-arrow-line ${isDarkMode ? 'chat-bot-text-wrapper-arrow-line--dark-mode' : ''}`} x1="6.54075" y1="58.86675" x2="19.12225" y2="58.86675" /> 
              {/* Vertical Line */}
              <line className={`chat-bot-text-wrapper-arrow-line ${isDarkMode ? 'chat-bot-text-wrapper-arrow-line--dark-mode chat-bot-text-wrapper-arrow-line--transparent' : ''}`} x1="19.62225" y1="57.56675" x2="20.2225" y2="45.95" />
              {/* Hypotenuse */}
              <line className={`chat-bot-text-wrapper-arrow-line ${isDarkMode ? 'chat-bot-text-wrapper-arrow-line--dark-mode' : ''}`} x1="6.54075" y1="58.86675" x2="19" y2="45.95"/>
              <polygon className={`chat-bot-text-wrapper-arrow-polygon ${isDarkMode ? 'chat-bot-text-wrapper-arrow-polygon--dark-mode' : ''}`} points="6.54075,58.86675 19.62225,58.86675 19.62225,45.78525" />
            </svg>
            <div className='chat-bot-text-header-wrapper'>
              <p className={`chat-bot-agent-title ${isDarkMode ? 'chat-bot-agent-title--dark-mode' : ''}`}>
                {currentChatbotCharacter}
              </p>
              <p className={`chat-bot-timestamp ${isDarkMode ? 'chat-bot-timestamp--dark-mode' : ''} ${product == 'HomeContentsInsurance' ? 'chat-bot-timestamp--home-insurance' : ''}`}>
                {moment().format('ddd D MMM, HH:mm')}
              </p>
            </div>
            <p className={`chat-bot-text ${isDarkMode ? 'chat-bot-text--dark-mode' : ''}`}>
              <TypeIt
                options={{
                  speed: 50,
                  lifeLike: true
                }}
                getAfterInit={(instance) => {
                  setInstance(instance);
                  return instance;
              }}>
              </TypeIt>
            </p>
            <div className='chat-bot-link-wrapper'>
              <button className={`chat-bot-link ${isDarkMode ? 'chat-bot-link--dark-mode' : ''} ${product == 'HomeContentsInsurance' ? 'chat-bot-link--home-insurance' : ''}`} onClick={() => show()}>
                {product == 'HomeContentsInsurance' ? 'Chat to a consultant' : 'Speak to consultant'}
              </button>
            </div>
          </div>
        </div>
        :
        null
      }
    </div>
  )
})

export default ChatBot